import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupplierTargetService {

  constructor(
    private http:HttpClient
  ) { }

  private urlGetSupplierTargetData: string = environment.baseURL + "api/TCSupplierTarget/GetAllSupplierTarget";
  private urlPostSupplierTargetData: string = environment.baseURL + "api/TCSupplierTarget/InsertOrUpdateBulkDataForSupplierTarget";
  private urlGetSupplierInfo: string = environment.baseURL + "api/TCSupplierTarget/GetSupplierInfo";

  getAllSupplierTargetData(businessAreaId?: number, businessLineId?: number){
    return this.http.get<any>(this.urlGetSupplierTargetData + '?businessAreaId=' + businessAreaId + '&businessLineId=' + businessLineId).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  postData(data){
    const httpOptions= {
      headers : new HttpHeaders({'Content-Type' : 'application/json'})
    }
    return this.http.post<any>(this.urlPostSupplierTargetData, data, httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  getAllSupplierInfoData(businessAreaId?: number, businessLineId?: number) {
    return this.http.get<any>(this.urlGetSupplierInfo + '?businessAreaId=' + businessAreaId + '&businessLineId=' + businessLineId).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  handleError(error: HttpErrorResponse){
    return throwError(error || "Server Error");
  }
}
